import {useEffect, useState} from "react";
import BodyContainer from "../components/BodyContainer";
import MessageBox from "../components/MessageBar";
import ProgressRing from "../components/ProgressRing";
import {getEvents} from "../handlers/eventhandler";
import SettingsItem from "../components/SettingsItem";
import Title from "../components/Title";
import {
    ArrowRight12Regular,
    ArrowRight20Regular,
    BookOpen20Regular,
    Calendar16Regular, Flag16Regular,
    Location16Regular
} from "@fluentui/react-icons";
import {Button, Card, CardFooter, CardHeader, Link, Subtitle2} from "@fluentui/react-components";
import {useNavigate} from "react-router-dom";
import { navigateToPage } from "../handlers/routehandler";
import IconText from "../components/IconText";
import {demoEvents} from "../models/Event";

const HomeView = () => {
    const navigate = useNavigate();

    const [events, setEvents] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [errorMsg, setErrorMsg] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            const eventResult = await getEvents();
            if (!eventResult) {
                setIsLoading(false);
                setErrorMsg("An error occurred while fetching events.");
            }

            setEvents(eventResult);
            setIsLoading(false);
        }

        fetchData().then(r => {});
    }, [])

    return (
      <BodyContainer content={
          <>
              {errorMsg != null ? <MessageBox intent={"error"} title={"Error loading events: "} message={errorMsg} closeButtonFunction={() => {setErrorMsg(null)}}/> : null}
              {errorMsg == null && !isLoading && !events.length && <MessageBox intent={"warning"} title={""} message={"No events found"} />}
              {isLoading && <ProgressRing/>}
              {events && events.length &&
                  <>
                      <Title title={"Welkom bij Klokking"} subtitle={"Selecteer een evenement om in te schrijven"}/>
                      <Link onClick={() => navigateToPage(`manual`)} style={{ display: "inline-flex", alignItems: "center", gap: "4px", marginTop: "4px", marginBottom: "8px" }}>
                          <BookOpen20Regular /> Handleiding & Informatie
                      </Link>
                      <div className={`desktop`}>
                          <div className={`flex flex-wrap flex-align-center flex-gap-medium flex-align-stretch`}>
                              {
                                  events.slice(0, 3).map((eventItem, index) => (
                                      <Card className={`card card-large`} key={index}>
                                          <div className={`card-large-body`}>
                                              <div className={`flex flex-column flex-align-center`}>
                                                  <Subtitle2>{eventItem.name}</Subtitle2>
                                              </div>
                                              <ul className={`ul-no-list flex flex-column flex-gap-small`}>
                                                  <li>
                                                      <div className={`flex flex-gap-medium`}>
                                                          <Location16Regular/>
                                                          <p className={`text-no-margin`}>{eventItem.location}</p>
                                                      </div>
                                                  </li>
                                                  <li>
                                                      <div className={`flex flex-gap-medium`}>
                                                          <Calendar16Regular/>
                                                          <p className={`text-no-margin`}>{`${eventItem.startDate} - ${eventItem.endDate}`}</p>
                                                      </div>
                                                  </li>
                                                  <li>
                                                      <div className={`flex flex-gap-medium`}>
                                                          <Flag16Regular/>
                                                          <p className={`text-no-margin`}>{eventItem.race_type}</p>
                                                      </div>
                                                  </li>
                                              </ul>
                                          </div>
                                          <CardFooter>
                                              <Button as={`a`} className={`button width-100`} appearance={`primary`} onClick={() => navigateToPage(`${eventItem.id}`)}>
                                                  Open Evenement
                                              </Button>
                                          </CardFooter>
                                      </Card>
                                  ))
                              }
                          </div>
                          {
                              events.slice(3).map((event, index) => (
                                  <SettingsItem
                                      key={index}
                                      title={event.name}
                                      text={<>{event.startDate} <ArrowRight12Regular/> {event.endDate}</>}
                                      buttonText={"Open Evenement"}
                                      buttonAppearance={"primary"}
                                      onClick={() => { navigate(`/${event.id}`); }}/>
                              ))
                          }
                      </div>
                      <div className={`mobile`}>
                          {
                              events.map((event, index) => (
                                  <SettingsItem
                                      key={index}
                                      title={event.name}
                                      text={<>{event.startDate} <ArrowRight12Regular/> {event.endDate}</>}
                                      buttonText={"Open Evenement"}
                                      buttonAppearance={"primary"}
                                      onClick={() => { navigate(`/${event.id}`); }}/>
                              ))
                          }
                      </div>
                  </>
              }
          </>
      } />
    );
}

export default HomeView;